module.exports = __webpack_public_path__ + "static/media/FATMA ALOMAR.95c31b35.png";